import { render, staticRenderFns } from "./BibliotecaCompact.vue?vue&type=template&id=b01b0904&scoped=true&"
import script from "./BibliotecaCompact.vue?vue&type=script&lang=ts&"
export * from "./BibliotecaCompact.vue?vue&type=script&lang=ts&"
import style0 from "./BibliotecaCompact.vue?vue&type=style&index=0&id=b01b0904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01b0904",
  null
  
)

export default component.exports